// extracted by mini-css-extract-plugin
module.exports = {"popup":"ArtistRecommendationsPopup_popup__32On5","headerTitle":"ArtistRecommendationsPopup_headerTitle__3w6Ue","popupItem":"ArtistRecommendationsPopup_popupItem__3bHII"};